export const layoutData = [

    // Type Employer Information Start
    {
        "name": "Employee ID",
        key: 'employeeCode',
        "type": "Employee Info",
        isSelected: false
    },
    {
        "name": "Names and Surnames (English)",
        key: 'fullName',
        "type": "Employee Info",
        isSelected: false
    },
    {
        "name": "Names and Surnames (Laos)",
        key: 'fullNameLao',
        "type": "Employee Info",
        isSelected: false
    },
    {
        "name": "Position",
        key: 'position',
        "type": "Employee Info",
        isSelected: false
    },
    {
        "name": "Department",
        key: 'department',
        "type": "Employee Info",
        isSelected: false
    },
    {
        "name": "Salary Grade",
        key: 'salaryGrade',
        "type": "Employee Info",
        isSelected: false
    },
    {
        name: "Start Working Date",
        key: 'startWorkingDate',
        "type": "Employee Info",
        isSelected: false
    },

    {
        "name": "Default Working Day / Month",
        key: 'defaultWorkingDay',
        "type": "Employee Info",
        isSelected: false
    },
    {
        "name": "Actual Work Day This month",
        key: 'actualWorkingDay',
        "type": "Employee Info",
        isSelected: false
    },
    {
        "name": "Email",
        key: 'email',
        "type": "Employee Info",
        isSelected: false
    },
    {
        "name": "Bank Name",
        key: 'bankAccount.bankName',
        "type": "Employee Info",
        isSelected: false
    },
    {
        "name": "Bank Account Name",
        key: 'bankAccount.accountName',
        "type": "Employee Info",
        isSelected: false
    },
    {
        "name": "Bank Account Number",
        key: 'bankAccount.accountNumber',
        "type": "Employee Info",
        isSelected: false
    },
    // Type Employer Information End
    // Type Earning - List Item start
    {
        key: 'earningsListBeforeSso',
        name: 'Earning Before SSO Calculation - List Item',
        type: 'Earning',
        isSelected: false
    },
    {
        key: 'earningsListAfterSso',
        name: 'Earning After SSO and Before TAX Calculation - List Item',
        type: 'Earning',
        isSelected: false
    },
    {
        key: 'earningsListAfterTax',
        name: 'Earning After TAX Calculation - List Item',
        type: 'Earning',
        isSelected: false
    },



    //Amount
    {
        key: 'earningBeforeSso',
        name: 'Sum of - Earning Before SSO Calculation',
        type: 'Earning',
        isSelected: false
    },
    {
        key: 'earningAfterSso',
        name: 'Sum of - Earning After SSO and Before TAX Calculation',
        type: 'Earning',
        isSelected: false
    },
    {
        key: 'earningAfterTax',
        name: 'Sum of - Earning After TAX Calculation',
        type: 'Earning',
        isSelected: false
    },
    // Amount

    // Type Earning - List Item start

    // {
    //     key: 'deductions',
    //     name: 'Deduction Before TAX Calculation - List Item',
    //     type: 'Deduction',
    //     isSelected: false
    // },
    // {
    //     key: 'deductions',
    //     name: 'Deduction After TAX Calculation - List Item',
    //     type: 'Deduction',
    //     isSelected: false
    // },
    // {
    //     key: 'deductions',
    //     name: 'Deduction Before SSO - List Item',
    //     type: 'Deduction',
    //     isSelected: false
    // },
    // {
    //     key: 'deductions',
    //     name: 'Deduction After SSO - List Item',
    //     type: 'Deduction',
    //     isSelected: false
    // },


    {
        key: 'deductionsListBeforeSso',
        name: 'Deduction Before SSO Calculation - List Item',
        type: 'Deduction',
        isSelected: false
    },
    {
        key: 'deductionsListAfterSso',
        name: 'Deduction After SSO and Before TAX Calculation - List Item',
        type: 'Deduction',
        isSelected: false
    },
    {
        key: 'deductionsListAfterTax',
        name: 'Deduction After TAX Calculation - List Item',
        type: 'Deduction',
        isSelected: false
    },

     //Amount
     {
        key: 'deductionBeforeSso',
        name: 'Sum of - Deduction Before SSO Calculation',
        type: 'Deduction',
        isSelected: false
    },
    {
        key: 'deductionAfterSso',
        name: 'Sum of - Deduction After SSO and Before TAX Calculation',
        type: 'Deduction',
        isSelected: false
    },
    {
        key: 'deductionAfterTax',
        name: 'Sum of - Deduction After TAX Calculation',
        type: 'Deduction',
        isSelected: false
    },

    // Amount
    // {
    //     key: 'deductions',
    //     name: 'Sum of - Deduction Before TAX Calculation',
    //     type: 'Deduction',
    //     isSelected: false
    // },
    // {
    //     key: 'deductions',
    //     name: 'Sum of - Deduction After TAX Calculation',
    //     type: 'Deduction',
    //     isSelected: false
    // },
    // {
    //     key: 'deductions',
    //     name: 'Sum of - Deduction Before SSO Calculation',
    //     type: 'Deduction',
    //     isSelected: false
    // },
    // {
    //     key: 'deductions',
    //     name: 'Sum of - Deduction After SSO Calculation',
    //     type: 'Deduction',
    //     isSelected: false
    // },
    //Amount


    // // Type Earning Deduction - Total Amount start
    // {
    //     key: 'deductibleBeforeTax',
    //     "name": "Total - Earning / Deduction Before TAX",
    //     "type": "Earning / Deduction - Total Amount",
    //     isSelected: false
    // },
    // {
    //     key: 'deductibleAfterTax',
    //     "name": "Total - Earning / Deduction After TAX ",
    //     "type": "Earning / Deduction - Total Amount",
    //     isSelected: false
    // },

    // {
    //     "name": "Total - Earning / Deduction Before SSO",
    //     key: 'deductibleBeforeSSO',
    //     "type": "Earning / Deduction - Total Amount",
    //     isSelected: false
    // },
    // {
    //     "name": "Total - Earning / Deduction After SSO",
    //     key: 'deductibleAfterSSO',
    //     "type": "Earning / Deduction - Total Amount",
    //     isSelected: false
    // },
    // // Type Earning Deduction End

    // Type SSO Start
    {
        "name": "Company SSO 6%",
        key: 'ssoPaidByCom',
        "type": "SSO",
        isSelected: false
    },
    {
        "name": "Employee SSO 5.5%",
        key: 'ssoPaidByEmp',
        "type": "SSO",
        isSelected: false
    },
    // Type SSO End


    // Type TAX Start
    {
        "name": "Total Due as Tax",
        "type": "TAX",
        key: 'totalDueAsTax',
        isSelected: false
    },
    // Type TAX End




    // Type Salary Start
    {
        "name": "This Month Salary",
        key: 'thisMonthSalary',
        "type": "Salary",
        isSelected: false
    },
    {
        "key": "finalNetPay",
        "name": "Final Net Pay",
        "type": "Salary",
        isSelected: false
    },
    {
        "name": "Basic Salary",
        key: 'basicSalary',
        "type": "Salary",
        isSelected: false
    },
    // Type Salary End
]